export default "__VITE_ASSET__Jl7YsRJB__"